import { PlanContext } from "../../context"
import { createObservationsMgr, ObservationsMgr } from "../../observations/manager"
import { canAddNewObservation } from "../../observations/observations"
import { PlanState } from "../../types"
import { Observation } from "./Observation"
import { Predefs } from "./Predefs"

interface Props {
    state: PlanState
}

export function Observations({ state }: Props) {

    const { selectedField } = state

    const observations = selectedField?.observations

    const { api, dispatch } = React.useContext(PlanContext)

    const canAdd = React.useMemo(() => canAddNewObservation(selectedField), [selectedField])

    const add = () => dispatch({ type: "addNewObservation" })

    const mgr = React.useMemo(

        () => createObservationsMgr(

            state.userObservations,

            selectedField?.activeObservation,

            update => {

                return api.updateUserObservation({
                    observation: update.observation,
                    action: update.action,
                    remove: !update.save
                }).then(() => {

                    dispatch({ type: "saveUserObservation", ...update })

                })

            }

        ),

        [state.userObservations, selectedField?.activeObservation, api, dispatch]

    )

    const active = useActiveObservation(state, mgr)

    if (!observations) {
        return null
    }

    return <div className="field-observations">

        <div className="hdr">

            <div className="o">
                <h3>Observations</h3>
                <button type="button" className="btn btn-addnew" title="New observation" disabled={!canAdd} onClick={add}>
                    <i className="fas fa-plus"></i>
                </button>
            </div>

            <div className="a">
                <h3>Actions</h3>
            </div>

        </div>

        <div className="list">

            {observations.map((obs, index) => <Observation obs={obs} key={index} mgr={mgr} />)}

        </div>

        {
            active &&
            <Predefs {...{ ...active, filter: state.settings.predefsFilter }} />
        }

    </div>

}


function useActiveObservation(state: PlanState, mgr: ObservationsMgr) {

    const { selectedField: field, observations: reference } = state
    const { obsActionsProvider } = reference

    const refObservations = React.useMemo(() => Object.values(reference.observations).sort((a, b) => a.text.localeCompare(b.text)), [reference.observations])

    const { dispatch } = React.useContext(PlanContext)

    return React.useMemo(() => {

        const active = field?.activeObservation

        if (!active) {
            return undefined
        }

        const obs = field.observations.find(o => o.key === active.observation)

        const action = obs && active.action
            ? obs.actions.find(a => a.key === active.action)
            : undefined

        const entries = action
            ? obsActionsProvider(obs.observationId)
            : refObservations

        const update = action
            ? (text: string) => dispatch({ type: "updateAction", obs, key: action.key, text })
            : (text: string) => dispatch({ type: "updateObservation", key: obs.key, text })

        return {

            entries,

            obs,
            action,

            update,

            mgr

        }



    }, [dispatch, mgr, obsActionsProvider, field, field?.activeObservation, refObservations])

}
